/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, December 2023
 */
import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './NotFound.css';

class WKCertNotFound extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          {this.props.title ? <h1>{this.props.title}</h1> : null}
          <div
            className={s.napis}
          >
            Nie można wyświetlić formularza e-usługi. 
            Brak integracji z Krajowym Węzłem Identyfikacji w zakresie identyfikacji i uwierzytelniania użytkownika.

            Prosimy o kontakt bezpośrednio z urzędem.
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(WKCertNotFound);



// WEBPACK FOOTER //
// src/routes/WKNotFound/WKCertNotFound.js